export default "__VITE_ASSET__VJ3GoMWG__"